module.exports = __webpack_public_path__ + "b3d0902b533ff4c4f1698a2f96ddabab.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-Regular.ttf
// module id = 1266
// module chunks = 0